(function () {
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var parcelRequire = $parcel$global["parcelRequirefdb2"];
parcelRequire.register("8Vk7g", function(module, exports) {
var accordionOpenEvent = new Event("accordionOpen", {
    bubbles: true
});
var accordionCloseEvent = new Event("accordionClose", {
    bubbles: true
});
var openAccordion = function(accordion) {
    var _accordion_dataset;
    // Open this accordion item
    var summaryEl = accordion.querySelector("summary");
    summaryEl.setAttribute("onclick", "return false");
    accordion.classList.add("open");
    accordion.classList.remove("closed");
    // If it's part of a group, collapse any siblings
    var group = accordion === null || accordion === void 0 ? void 0 : (_accordion_dataset = accordion.dataset) === null || _accordion_dataset === void 0 ? void 0 : _accordion_dataset.group;
    if (group) {
        var thisGroup = document.querySelectorAll('[data-group="'.concat(group, '"]'));
        Array.from(thisGroup).forEach(function(groupAccordion) {
            if (groupAccordion !== accordion) closeAccordion(groupAccordion);
        });
    }
    accordion.dispatchEvent(accordionOpenEvent);
};
var closeAccordion = function(accordion) {
    accordion.classList.remove("open");
    accordion.classList.add("closed");
    // If the item is not animated, just close it immediately
    if (!accordion.hasAttribute("data-animate")) {
        accordion.querySelector("summary").removeAttribute("onclick", "return false");
        accordion.open = false;
    }
    accordion.dispatchEvent(accordionCloseEvent);
};
var setAccordionHeightVar = function(accordion) {
    // Start by calculating the inner heihgt of the accordion content and save as a css var for our animations to use
    var contentEl = accordion.querySelector(".js-accordion__content");
    var articleContentHeight = contentEl.offsetHeight;
    accordion.style.setProperty("--accordion-article-height", "".concat(articleContentHeight, "px"));
};
var accordionGroups = document.getElementsByClassName("js-accordion__item");
if (!accordionGroups) return;
Array.from(accordionGroups).forEach(function(accordion) {
    // Set initial content height
    setAccordionHeightVar(accordion);
    // Manually apply an open and closed class that trigger keyframe animations
    accordion.addEventListener("click", function(e) {
        if (e.target.nodeName !== "SUMMARY") return;
        // Recalc contents height
        setAccordionHeightVar(accordion);
        // When the accordion opens, prevent closing on next click
        if (!accordion.open) openAccordion(accordion);
        if (accordion.open) closeAccordion(accordion);
    });
    // If the accordion is animated we need to listen for the animation end event and then close it
    if (accordion.hasAttribute("data-animate")) accordion.addEventListener("animationend", function(e) {
        if (e.animationName === "hideArticle") {
            accordion.open = false;
            accordion.querySelector("summary").removeAttribute("onclick", "return false");
        }
    });
});

});

})();
//# sourceMappingURL=accordion.3d8c38d6.js.map
